import React from 'react';
import cn from 'classname';
import './index.less';

import PayoutIsUrgentIcon from '../../components/payout-is-urgent-icon';
import PayoutDate from '../components/payout-date';
import PayoutStatus from '../components/payout-status';
import PayoutAmount from '../components/payout-amount';
import PayoutAmountWithPercentWrapper from '../components/payout-amount-with-percent-wrapper';
import PayoutErrorMessage from '../components/payout-error-message';
import PayoutActions from '../components/payout-actions';
import PayoutAction from '../components/payout-action';
import PayoutActionCanBeAllowed from '../components/payout-action-can-be-allowed';
import PayoutActionButton from '../components/payout-action-button';

import { enum as payoutStatuses } from '../../../../../../../../../../enums/payout-statuses';

function PayoutSubRow({ isOpen, isFirst, payout, payoutSystem, isToPayColumnShouldBeShown, actions }) {
	return (
		<tr className={cn('payout-table--body--sub-row', payout.status, {
			'opened': isOpen,
			'first': isFirst
		})}>
			<td />
			<td>
				<PayoutIsUrgentIcon active={payout.is_urgent} />
			</td>
			<td>
				<PayoutDate date={payout.created_at} />
			</td>
			<td>
				<PayoutStatus status={payout.status} />
			</td>
			<td>PayoutID: {payout.id}</td>
			<td className='text-align-right'>
				<PayoutAmount
					amount={payout.amount}
					currency={payoutSystem.currency}
					keepDecimals={payoutSystem.allow_floats}
				/>
			</td>
			{isToPayColumnShouldBeShown && (
				<td className='text-align-right'>
					<PayoutAmountWithPercentWrapper
						percent={payout.payout_percent}
						isPercentShouldBeShown={payout.payout_percent !== +payoutSystem.payout_percent}
						fee={payout.payout_fee}
						isFeeShouldBeShown={
							payout.payout_fee !== null && payout.payout_fee !== +payoutSystem.payout_fee
						}
						currency={payoutSystem.currency}
					>
						<PayoutAmount
							amount={payout.amount_to_pay}
							currency={payoutSystem.currency}
							keepDecimals={payoutSystem.allow_floats}
						/>
					</PayoutAmountWithPercentWrapper>
				</td>
			)}
			<td>
				{(payout.status === payoutStatuses.approved && payout.error_message) && (
					<PayoutErrorMessage error={payout.error_message} />
				)}
			</td>
			<td colSpan={3} />
			<td>
				<PayoutActions>
					<PayoutAction column={1} processing={payout.isInProcessing}>
						<PayoutActionCanBeAllowed
							action='confirm'
							status={payout.status}
						>
							{(isAllowed) => isAllowed && (
								<PayoutActionButton
									onClick={() => actions.confirm([payout])}
								>
									Confirm
								</PayoutActionButton>
							)}
						</PayoutActionCanBeAllowed>
					</PayoutAction>
					<PayoutAction column={2} processing={payout.isInProcessing} />
					<PayoutAction column={3} processing={payout.isInProcessing}>
						<PayoutActionCanBeAllowed
							action='reject'
							status={payout.status}
						>
							{(isAllowed) => isAllowed && (
								<PayoutActionButton
									onClick={() => actions.reject([payout])}
								>
									Reject
								</PayoutActionButton>
							)}
						</PayoutActionCanBeAllowed>
					</PayoutAction>
				</PayoutActions>
			</td>
		</tr>
	);
}

export default PayoutSubRow;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/table/components/payout-body/payout-sub-row/index.js